import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../../Common/Components/Form";
import { useProblem } from "../Hooks";
function Create() {
    const initialState = {
        loading: false,
    };
    const [state, setstate] = useState(initialState);
    const {
        sendData
    } = useProblem();
    const Handler = data => {
        setstate({ loading: true });
        sendData({ ...data }).then(() => {
            setstate({
                loading: false,
            });
        });
    };

    return (
        <Fragment>
            <Helmet>
                <title>نیکوتن | ثبت کاربر</title>
            </Helmet>
            <CommonFrom
                form={input}
                loading={state.loading}
                header="ثبت مشکل"
                textbtn="لیست مشکلات"
                linkbtn="/Admin/UserProble"
                btnName="ثبت  گزارش مشکل"
                submit={Handler}
            />
        </Fragment>
    );
}

export default Create;

export const input = [
    {
        label: "نام کاربر",
        size: "col-md-4",
        classNames: "mt-2",
        placeholder: "",
        name: "fullname",
        type: "text",
    },
    {
        label: "شماره موبایل",
        size: "col-md-4",
        classNames: "mt-2",
        placeholder: "",
        name: "mobile",
        type: "text",
    },
    {
        label: "محل مشکل",
        size: "col-md-4",
        classNames: "mt-2",
        placeholder: "",
        name: "path",
        type: "text",
    },
    {
        label: "توضیح",
        size: "col-md-12",
        classNames: "mt-2",
        placeholder: "",
        name: "describe",
        input: "textarea",
    },
];
